import { useEffect, useMemo, useState } from "react";
import "@/App.css";
import { SiteContext, startLenis } from "@/lib/site";
import { content } from "@/content";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Projects } from "@/components/site/Projects";
import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("rb-lang") || "es");
  const [theme, setTheme] = useState(() => localStorage.getItem("rb-theme") || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("light", theme === "light");
    localStorage.setItem("rb-theme", theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("rb-lang", lang);
  }, [lang]);

  useEffect(() => {
    const stop = startLenis();
    return stop;
  }, []);

  const value = useMemo(() => ({ lang, setLang, theme, setTheme, t: content[lang] }), [lang, theme]);

  return (
    <SiteContext.Provider value={value}>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Projects />
        <About />
        <Contact />
      </main>
      <Footer />
    </SiteContext.Provider>
  );
}

export default App;
